import { render } from "./GenericGroup.vue?vue&type=template&id=346c1214"
import script from "./GenericGroup.vue?vue&type=script&lang=js"
export * from "./GenericGroup.vue?vue&type=script&lang=js"

import "./GenericGroup.vue?vue&type=style&index=0&id=346c1214&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__